export class ItemPricing {
  constructor() {
    this.Item = "";
    this.EffectDate = new Date();
    this.UnitPrice = 0.0;
    this.BreakPrice1 = 0.0;
    this.BreakPrice2 = 0.0;
    this.BreakPrice3 = 0.0;
    this.BreakPrice4 = 0.0;
    this.BreakPrice5 = 0.0;
    this.BreakQty1 = 0.0;
    this.BreakQty2 = 0.0;
    this.BreakQty3 = 0.0;
    this.BreakQty4 = 0.0;
    this.BreakQty5 = 0.0;
    this.Description = "";
    this.Description2 = "";
    this.EstimatedLeadTime = "";
    this.ActiveForCustomerPortal = false;
    this.PortalPricingEnabled = false;
    this.OverridePricingRules = false;
    this.QtyAvailable = 0;
    this.InventoryItem = false;
    this.CrateRequiredFlag = false;
    this.ProductURL = "";
    this.ProductImageURL = "";
    this.CustomMessage = "";
  }

  public Item: string;
  public EffectDate: Date;
  public UnitPrice: number;
  public BreakPrice1: number;
  public BreakPrice2: number;
  public BreakPrice3: number;
  public BreakPrice4: number;
  public BreakPrice5: number;
  public BreakQty1: number;
  public BreakQty2: number;
  public BreakQty3: number;
  public BreakQty4: number;
  public BreakQty5: number;
  public Country: string;
  public HTSCode: string;
  public Description: string;
  public Description2: string;
  public EstimatedLeadTime: string;
  public CustomMessage: string;
  public ActiveForCustomerPortal: boolean;
  public PortalPricingEnabled: boolean;
  public ItemStatus: string;
  public OverridePricingRules: boolean;
  public QtyAvailable: number;
  public InventoryItem: boolean;
  public CrateRequiredFlag: boolean;
  public ProductURL: string;
  public ProductImageURL: string;
}
